var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 8 1.1011 7.69091 1.33548 7.22644C1.37179 7.1545 1.41129 7.07883 1.45411 7C2.2467 5.54084 4.17588 3 8 3C13.3645 3 15 8 15 8C15 8 13.3536 13 8 13C2.63551 13 1 8 1 8ZM13.9241 7.99907C13.883 7.90564 13.8313 7.79465 13.7683 7.67018C13.5585 7.25542 13.2292 6.70293 12.7548 6.15358C11.8175 5.06819 10.3257 4 8 4C5.67434 4 4.18247 5.06819 3.24517 6.15358C2.77079 6.70293 2.44151 7.25542 2.23167 7.67018C2.1685 7.79506 2.11669 7.90638 2.07546 8C2.11669 8.09362 2.1685 8.20494 2.23167 8.32982C2.44151 8.74458 2.77079 9.29707 3.24517 9.84642C4.18247 10.9318 5.67434 12 8 12C10.3197 12 11.8119 10.9322 12.7511 9.84594C13.2264 9.29631 13.5567 8.74353 13.7674 8.32853C13.8308 8.20382 13.8827 8.09264 13.9241 7.99907Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4f340acb48888e1785240f722e6e62ce.svg";
export { ForwardRef as ReactComponent };